module.exports = __webpack_public_path__ + "static/media/money-packs-icon.00930449.svg";